module.exports = __webpack_public_path__ + "img/carryon.83b824cf.png";